import { Icon } from 'components/ui';
import React, { useState } from 'react';
import { snakeCase } from 'lodash';
import { TYPES } from 'constants/config';
import { CheckCircle, File } from 'react-feather';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { LabeledCheckbox } from 'components/shared/checkbox';
import StepIndicator from './StepIndicator';
import ActionButton from './ActionButton';
import TaskButton from './TaskButton';

const renderStepIcon = type => {
  switch (type) {
    case TYPES.LESSON:
      return <File className="JourneyContent-icon" size={20} />;
    case TYPES.PATH:
      return <Icon className="JourneyContent-icon" name="path" />;
    case TYPES.TASK:
      return <CheckCircle className="JourneyContent-icon" size={20} />;
    default:
      return null;
  }
};

const Step = ({ step, index }) => {
  const { completedSteps, currentStep, steps, journeyId } = useSelector(
    state => state,
  );

  const [submittable, setSubmittable] = useState(false);
  const [showToolTip, setshowToolTip] = useState(false);

  function createMarkup() {
    return { __html: step.description };
  }

  const unavailable = step.stepId !== currentStep && index > completedSteps;
  const unavailableStyles = { opacity: 0.6 };

  if (step.type === TYPES.TASK) {
    return (
      <div
        className="JourneyContentWrapper"
        data-testid="JourneyContentWrapper"
      >
        <div
          className={classNames('JourneyContent')}
          style={unavailable ? unavailableStyles : {}}
        >
          <div className="w-fill">
            <div className="JourneyContent-header">
              <div
                className={classNames('JourneyContent-title')}
                data-testid="JourneyContent-title"
              >
                <div>{renderStepIcon(step.type)}</div>
                <h1>{step.title}</h1>
              </div>
              <div className="JourneyContent-availability">
                {step.stepId !== currentStep && index > completedSteps && (
                  <p>{t('journeys.viewer.availability')}</p>
                )}
              </div>
            </div>

            <div className="JourneyContent-content">
              {currentStep === step.stepId && (
                <div>
                  <div
                    className="JourneyContent-description f-smooth"
                    dangerouslySetInnerHTML={createMarkup()}
                  />
                  <div className="JourneyContent-button">
                    <LabeledCheckbox
                      className="JourneyContent-checkboxlabel"
                      checkBoxClassName="JourneyContent-checkbox"
                      onChange={e => setSubmittable(e.target.checked)}
                      label={
                        <>
                          <span className="JourneyContent-checkboxtext">
                            {t('journeys.task.check_box')}
                          </span>
                        </>
                      }
                    />
                  </div>
                  {showToolTip && (
                    <div className="JourneyContent-tooltip">
                      <Icon className="fz-bigger" name="info" />
                      <div className="JourneyContent-tooltiptext">
                        {t('journeys.task.tool_tip')}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            {currentStep === step.stepId && (
              <TaskButton
                journeyId={journeyId}
                submittable={submittable}
                showToolTip={setshowToolTip}
                status={step.status}
              />
            )}
          </div>
        </div>
        <StepIndicator
          {...{
            stepNumber: steps.findIndex(x => x.stepId === step.stepId) + 1,
            status: step.status,
            progress: step.progress,
            id: step.stepId,
            stepIndex: index,
          }}
        />
      </div>
    );
  }

  return (
    <div className="JourneyContentWrapper" data-testid="JourneyContentWrapper">
      <div
        className={classNames('JourneyContent', {
          JourneyPath: step.type === TYPES.PATH,
        })}
        style={unavailable ? unavailableStyles : {}}
      >
        <div className="w-fill">
          <div className="JourneyContent-header">
            <div
              className={classNames('JourneyContent-title', {
                'JourneyContent-title--path': step.type === TYPES.PATH,
              })}
              data-testid="JourneyContent-title"
            >
              <div>{renderStepIcon(step.type)}</div>
              <h1>{step.title}</h1>
            </div>
            {unavailable && (
              <div className="JourneyContent-availability">
                <p>{t('journeys.viewer.availability')}</p>
              </div>
            )}
          </div>
          {!!step.description && (
            <div className="JourneyContent-content">
              <p className="JourneyContent-description f-smooth">
                {step.description}
              </p>
            </div>
          )}
          {step.type === TYPES.PATH && step.contents && (
            <div className="JourneyPath-content">
              {step.contents.map(content => {
                return (
                  <div
                    key={snakeCase(content.type + content.id)}
                    className="JourneyPath-lesson"
                  >
                    <File className="JourneyContent-icon" size={16} />
                    <span>{content.title}</span>
                  </div>
                );
              })}
            </div>
          )}
          {currentStep === step.stepId && (
            <ActionButton
              status={step.status}
              type={step.type}
              urls={step.urls}
              progress={step.progress}
            />
          )}
        </div>
      </div>
      <StepIndicator
        {...{
          stepNumber: steps.findIndex(x => x.stepId === step.stepId) + 1,
          status: step.status,
          progress: step.progress,
          id: step.stepId,
          stepIndex: index,
        }}
      />
    </div>
  );
};

export default Step;
